import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { WindowRef } from '../../utils/window';
import { APP_CONSTANTS } from '../../utils/app-constants';
import { TranslateUtil } from '../../utils/translate-util';
import { Banner } from "../../shared/models/banner";
import { DTFHomepageService } from "../dtfhomepage/dtfhomepage.service";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatPaginator } from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { SharedTranslateModule } from "../../utils/sharedTranslateModule";



@Component({
    selector: "div.dtf-paymentOptionpage",
    imports: [SharedTranslateModule,
        MatTableModule, MatCheckboxModule, MatFormFieldModule,
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, MatSortModule
    ],
    templateUrl: './paymentOption.component.html',
    providers: [
    //  ClassesUtil, WindowRef
    ]
})
export class PaymentOptionComponent implements OnInit {
  router: Router;
  isCanadaPortal = false;
  currentCountry: string;
  language = '';
  isFrench = false;
  targetRedirect = '';
  usUrl: string;
  caUrl: string;
  toggleOpen: any;
  public alerts: Banner;
  dbData: any;
  azURL: string;
  baseRedirect = '';
  countryFlag: string;
  langFlag: string;
  bodyLoaded = false;
  accountRedirect = '';
  token: string;

  constructor(
    router: Router,
    public translate: TranslateService,
    private _window: WindowRef,
    public dtfhomepageService: DTFHomepageService,
    public translateUtil: TranslateUtil
  ) {
    this.router = router;
}
  ngOnInit() {
    const language = (window as any).mbfs.language;
    this.translateUtil.getCurrentCountry().subscribe(val => {
      this.isCanadaPortal = (val === APP_CONSTANTS.COUNTRY_CA) ? true : false;
    });
    //this.getAlerts();
    this.langInit();
  }

  anouncementMgsopen(e: any) {
    e.preventDefault();
    if (this.toggleOpen) {
      this.toggleOpen = false;
    } else {
      this.toggleOpen = true;
    }
  }

  langInit() {
    // Initializes Language and all URL's for href
    this.language = (this._window.nativeWindow as any).mbfs.language;
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;
    const usePrivacy = (window as any).mbfs.usePrivacy;
  }
  formatAccountURl(redirect: string) {
    this.bodyLoaded = true;
    window.scrollTo(0, 0); // used to scroll to top of page
    if (this.countryFlag === 'CA') //CA Logic
    {
      this.azURL =  this.accountRedirect + '?blink=' + redirect;
      if(this.langFlag === 'fr-CA'){
         
           if (redirect === 'useAndPrivacy'){
            this.azURL =  this.usUrl + '/ca/fr/home/useAndPrivacy';
          }
          else if (redirect ==='ccpa'){
            this.azURL =  this.usUrl + '/ca/fr/home/ccpa';
          }
         
      }
      else{
        if (redirect === 'useAndPrivacy'){
          this.azURL =  this.usUrl + '/ca/en/home/useAndPrivacy';
        }
        else if (redirect ==='ccpa'){
          this.azURL =  this.usUrl + '/ca/en/home/ccpa';
        }
      }
    }
    else{ //US Logic
      this.azURL =  this.accountRedirect + '?blinkImage=null&blink=' + redirect;
      if (redirect === 'useAndPrivacy'){
        this.azURL =  this.usUrl + '/home/useAndPrivacy';
      }
    
      else if (redirect ==='ccpa'){
        this.azURL =  this.usUrl + '/home/ccpa';
      }

    }
    setTimeout(() => {
      this._window.nativeWindow.location.href = this.azURL;
  }, 1000);  //1s
  }

}
